import { render, staticRenderFns } from "./BankFormComponent.vue?vue&type=template&id=b631707a&scoped=true"
import script from "./BankFormComponent.vue?vue&type=script&lang=js"
export * from "./BankFormComponent.vue?vue&type=script&lang=js"
import style0 from "./BankFormComponent.vue?vue&type=style&index=0&id=b631707a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b631707a",
  null
  
)

export default component.exports